import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";

interface ForgotPasswordLinkProps {
  url: string;
}

export const ForgotPasswordLink = ({ url }: ForgotPasswordLinkProps) => {
  const { currentCommunityPolicies } = useCurrentCommunityContext();

  const showForgotPasswordButton =
    !currentCommunityPolicies.custom_login_enabled ||
    currentCommunityPolicies.customLoginAllowSignInWithCircle;

  if (!showForgotPasswordButton) {
    return null;
  }

  return (
    <div className="mt-2">
      <div className="text-md line-height-[20px]">
        <Link to={url} className="transition duration-150 ease-in-out">
          {t("authentication_app.shared_links.forgot_password")}
        </Link>
      </div>
    </div>
  );
};
